import script from "./CandidateButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CandidateButton.vue?vue&type=script&setup=true&lang=ts"

import "./CandidateButton.vue?vue&type=style&index=0&id=51571531&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/K8S-上海阿里云Prod环境-UOTS-Front/frontend/front-uots-simulator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51571531"]])

export default __exports__